module.exports = __webpack_public_path__ + "static/img/img_logo@2x.ab8332b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_logo@2x.png
// module id = fjnM
// module chunks = 0